import { apiClient } from "src/careflow/ph-core/api_client/api_client";

export interface FirebaseCustomTokenResponse {
  accessToken: string;
}

export const getFirebaseCustomToken = async (): Promise<string | null> => {
  try {
    const data = await apiClient.get<FirebaseCustomTokenResponse>(`auth/firebase/token`);
    return data?.accessToken;
  } catch (error) {
    console.log('Error retrieving firebase token:', error);
    return null;
  }
};
